/*
 * ██████╗ ██╗████████╗███████╗ █████╗  ██████╗████████╗ ██████╗ ██████╗ ██╗   ██╗
 * ██╔══██╗██║╚══██╔══╝██╔════╝██╔══██╗██╔════╝╚══██╔══╝██╔═══██╗██╔══██╗╚██╗ ██╔╝
 * ██████╔╝██║   ██║   █████╗  ███████║██║        ██║   ██║   ██║██████╔╝ ╚████╔╝
 * ██╔══██╗██║   ██║   ██╔══╝  ██╔══██║██║        ██║   ██║   ██║██╔══██╗  ╚██╔╝
 * ██████╔╝██║   ██║   ██║     ██║  ██║╚██████╗   ██║   ╚██████╔╝██║  ██║   ██║
 * ╚═════╝ ╚═╝   ╚═╝   ╚═╝     ╚═╝  ╚═╝ ╚═════╝   ╚═╝    ╚═════╝ ╚═╝  ╚═╝   ╚═╝
 *
 *
 * Copyright (c) Bitfactory GmbH. All rights reserved.
 * https://www.bitfactory.io
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS
 * FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 * COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT,
 * INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES INCLUDING,
 * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN
 * ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */

import React, { ReactElement } from 'react';
import { observer } from 'mobx-react';
import StudentManagementViewStyles from './StudentManagementViewStyles';
import { Box, CircularProgress } from '@material-ui/core';
import { StudentManagementViewModel } from './StudentManagementViewModel';
import { useViewModel } from '../../../../hooks/useViewModel';
import CourseHeaderView from '../CourseHeader/CourseHeaderView';
import CourseTableView from '../CourseTable/CourseTableView';

const StudentManagementView = observer((): ReactElement => {
	const classes = StudentManagementViewStyles();
	const viewModel: StudentManagementViewModel = useViewModel(StudentManagementViewModel);

	return (
		<>
			<Box className={classes.contentContainer}>
				<CourseHeaderView
					buttonFunction={() => viewModel.createStudent(viewModel.getCourse().courseId)}
					buttonDisabled={viewModel.getDisableButton()}
					buttonText={'students.invite_student'}
					title={'students.student_management.title'}
				/>
				{viewModel.isLoading() ? (
					<Box className={classes.loadingContainer}>
						<CircularProgress className={classes.loading} />
					</Box>
				) : (
					<CourseTableView
						rows={viewModel.getStudents()}
						columns={viewModel.columns}
						menuItems={viewModel.menuItems}
						isNewAddedRow={viewModel.highlightNewlyAddedStudent()}
						emptyTableMessage={'students.student_management.table.empty_table'}
					/>
				)}
			</Box>
		</>
	);
});

export default StudentManagementView;
